import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Конфигурация GTM ID для каждого роута
const GTM_CONFIG = {
  'compatibility-long': 'GTM-MKLDD9BM',
  'compatibility-short': 'GTM-PD2TGN9N',
  'pope-long': 'GTM-KC9Q84G6',
  'pope-short': 'GTM-5Q9WDCKX',
  tarot: 'GTM-P89WKMBD',
  'tarot-chat': 'GTM-WTTXH3WT',
  vanga: 'GTM-KHDR2XQK',
  witch: 'GTM-MLCFSQCQ',
} as const;

type GTMConfigKey = keyof typeof GTM_CONFIG;

// Функция для получения GTM ID по пути
const getGTMIdByPath = (pathname: string): string | null => {
  const path = pathname.split('/')[1]; // Получаем первый сегмент пути
  return GTM_CONFIG[path as GTMConfigKey] || null;
};

// Функция для загрузки GTM скрипта
const loadGTMScript = (gtmId: string): void => {
  // Проверяем, не загружен ли уже этот GTM
  const existingScript = document.querySelector(`script[src*="${gtmId}"]`);
  if (existingScript) {
    return;
  }

  // Создаем и добавляем GTM скрипт
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
  document.head.appendChild(script);

  // Инициализируем GTM
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(args);
  }
  gtag('js', new Date());
  gtag('config', gtmId);

  // Добавляем gtag в window для глобального доступа
  (window as any).gtag = gtag;
};

// Функция для удаления GTM скриптов
const removeGTMScripts = (): void => {
  const gtmScripts = document.querySelectorAll('script[src*="googletagmanager.com"]');
  gtmScripts.forEach((script) => script.remove());

  // Очищаем dataLayer
  if (window.dataLayer) {
    window.dataLayer = [];
  }
};

export const useGoogleTagManager = () => {
  const location = useLocation();

  useEffect(() => {
    const gtmId = getGTMIdByPath(location.pathname);

    if (gtmId) {
      // Удаляем предыдущие GTM скрипты
      removeGTMScripts();

      // Загружаем новый GTM скрипт
      loadGTMScript(gtmId);

      // eslint-disable-next-line no-console
      console.log(`GTM loaded for route: ${location.pathname} with ID: ${gtmId}`);
    }
  }, [location.pathname]);
};

// Типы для TypeScript
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
} 